import Head from "next/head";
import EmailSignupBanner from "../../components/EmailSignupBanner";
import Layout from "../../components/Layout";
import { Divider, Space, Text, Title} from '@mantine/core'
import { MenuId } from "../../components/Header";
import styles from './public-vote.module.scss'


import { RusAuthProps, RusContextProps } from "../../lib/definitions";





import Link from "next/link";
import Image from 'next/image';

import imgAandI from './images/a-and-i.png';
import imgCBPP from './images/cbpp.jpg';
import imgMallGalleries from './images/mall-galleries.png';
import imgRP from './images/the-rp-high-res.jpg';
import imgBanner from './images/results-banner.jpg';
import { logEvent } from "../../lib/logger";


export default function Results({data} : {data: RusAuthProps & RusContextProps})
{
 
    return(
        <>
      
        <Layout menuId={MenuId.online}>

  
  <Head>
      <title>Paint Off 2024</title>
      <meta name="description" content="Find out what happened at the the Raw Umber Studios Paint Off"/>    
      <Head>
            <title>Raw Umber Studios Portrait Paint Off 2024</title>
            <meta name='description' content="Find out what happened at the the Raw Umber Studios Paint Off"/>
            <meta property='og:image' content='https://rawumberstudios.com/n/paintoff-1200x630.png'/>
            <meta property='og:image-width' content='1200'/>
            <meta property='og:image-height' content='630'/>
        </Head>  
  </Head>
  <div className = {styles.mainContent}>
                  <h1>
                <Image priority src={imgBanner} width={700} alt='Raw Umber Studios Portrait Paint Off 2024'/>
                </h1>
  <h1 className={styles.h1}>Portrait Paint Off 2024</h1>
    <Text>On 16th August 2024, eleven of the UK&rsquo;s top portrait artists joined us at Mall Galleries and spent a day painting from life. We filmed them painting, interviewed them, and talked to the judges. The result is a fascinating 60 minute documentary, full of insights about their processes and painting in general.</Text>

    <Text mt='md'>Want to find out happened? <Link href='/n/subscription' onClick={()=>{logEvent('po-results-24', {action:'subscribe'})}}>Subscribe</Link> (you&rsquo;ll need a Standard or Gold subscription) and <Link href='/videos/paint-off-2024-the-movie' onClick={()=>{logEvent('po-results-24', {action:'full'})}}>watch the full documentary</Link></Text>
    <Text>Or <Link href='https://youtu.be/nMy3drvwX8k' onClick={()=>{logEvent('po2024-yt', {})}}>watch the abridged version on YouTube</Link> for FREE</Text>
    <Text>Don&rsquo;t have the time and just want to find out who the winner was? Go <Link onClick={()=>{logEvent('po-results-24', {action:'winner'})}} href='/paint-off-2024-winner'>here</Link></Text>
    <Text mt='md'>As well as a prize worth £2,500 awarded by our judges (Stephen Bauman, Lizet Dingemans and Cornelia Hernes), we awarded a second, £1,000 cash prize, chosen by you the public. To see the winner, go <Link  onClick={()=>{logEvent('po-results-24', {action:'mod'})}} href='/paint-off-2024-peoples-choice-winner-announced'>here</Link></Text>    
  </div>
  
  <Space h='lg'/>
  

<div>
<Divider my="sm" variant="dotted" />
<Title order={3} mb='sm' ta="center">We&rsquo;d like to thank our supporters. In alphabetical order, they are:</Title>

<div style={{display:'flex', flexDirection:'row', flexWrap:'wrap', justifyContent:'center'}}>
    <div className={styles.logo}><a href='https://www.artistsandillustrators.co.uk/' target='_blank'><Image src={imgAandI} width={250} alt='Artists & Illustrators Logo'/></a></div>
    <div className={styles.logo}><a href='https://www.thecbpp.org' target='_blank'><Image src={imgCBPP} width={250} alt='CBPP Logo'/></a></div>
    <div className={styles.logo}><a href='https://www.mallgalleries.org.uk' target='_blank'><Image src={imgMallGalleries} width={250} alt='Mall Galleries Logo'/></a></div>
    <div className={styles.logo}><a href='https://therp.co.uk/' target='_blank'><Image src={imgRP} width={250} alt='The RP Logo'/></a></div>
</div>
</div>

  <EmailSignupBanner/>
  </Layout>



        </>

    );
  }

  
